module.exports = __webpack_public_path__ + "img/chen-yuxia-qingtong-workshop.31bad840.jpg";